import { render, staticRenderFns } from "./LogActividades.vue?vue&type=template&id=55dd230e&"
import script from "./LogActividades.vue?vue&type=script&lang=js&"
export * from "./LogActividades.vue?vue&type=script&lang=js&"
import style0 from "./LogActividades.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports